import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { useContext, useState } from 'react'
import AiClientForm from "@/src/components/AiClientForm"
import { JobHistory } from "@/src/components/upload/JobHistory"
import { getEnvironmentSetting } from '@/src/api/environmentSetting'
import { AuthContext } from '@/src/components/AuthContextProvider' 
import { GlobalBanner } from '../../components/upload/GlobalBanner'
import { OrganizationUpload } from './-OrganizationUpload' 

export const Route = createFileRoute('/upload/')({
  component: UploadPage,
})


export function UploadPage() {
  const auth = useContext(AuthContext)
  const user = auth?.user
  const [processingIds, setProcessingIds] = useState<string[]>([])

  const { data: bannerSetting } = useQuery({
    queryKey: ['environmentSetting', 'global_banner'],
    queryFn: () => getEnvironmentSetting({ data: { key: 'global_banner' } }),
  })

  const globalBanner = bannerSetting?.value as { html?: string; color?: string } | undefined
  const globalBannerHtml = globalBanner?.html
  const globalBannerColor = globalBanner?.color || '#fef3c7'

  // If user is logged in and has an organization, show organization page
  const hasOrganization = user?.organization

  return (
    <main className="flex grow flex-col items-center justify-start sm:justify-center px-4 py-4 sm:p-8">
      <div className="w-full max-w-xl">
        {globalBannerHtml && (
          <GlobalBanner html={globalBannerHtml} color={globalBannerColor} />
        )}
        {hasOrganization ? (
          <OrganizationUpload 
            organization={user.organization} 
            globalBannerColor={globalBannerColor}
            onProcessingIdsChange={setProcessingIds}
          />
        ) : (
          <>
            <div className="mb-4 flex justify-center items-center gap-4">
              <img
                src="/favicon.svg"
                alt="GearLens Logo"
                width={96}
                height={96}
                className="select-none dark:invert h-20 w-20 sm:h-24 sm:w-24"
              />
            </div>
            <AiClientForm onProcessingIdsChange={setProcessingIds} />
          </>
        )}
        <JobHistory processingIds={processingIds} />
      </div>
    </main>
  )
}
